export default {
  green: '#52995C',
  lightGreen: '#97BA98',
  red: '#e4002b',
  gray1: '#9b9b9b',
  gray2: '#4a4a4a',
  gray3: "#545454",
  white: '#fff',
  black: '#000'
};
